/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Pillar_IntroInputs */

const es_cap_pillar_intro = /** @type {(inputs: Cap_Pillar_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A medida que más barcos salen a navegar, crece la demanda de patrones titulados. Zarpar te conecta con ese trabajo y te deja todo el control.`)
};

const gl_cap_pillar_intro = /** @type {(inputs: Cap_Pillar_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Á medida que máis barcos saen a navegar, medra a demanda de patróns titulados. Zarpar conéctate con ese traballo e déixache todo o control.`)
};

const en_cap_pillar_intro = /** @type {(inputs: Cap_Pillar_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As more boats go sailing, demand for qualified skippers grows. Zarpar connects you with that work and leaves you in control.`)
};

/**
* | output |
* | --- |
* | "As more boats go sailing, demand for qualified skippers grows. Zarpar connects you with that work and leaves you in control." |
*
* @param {Cap_Pillar_IntroInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_pillar_intro = /** @type {((inputs?: Cap_Pillar_IntroInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Pillar_IntroInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_pillar_intro(inputs)
	if (locale === "en") return en_cap_pillar_intro(inputs)
	return es_cap_pillar_intro(inputs)
});